import React, { Component } from 'react';
import { Table, Button } from "antd";
import moment from "moment-timezone";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { deleteDocument } from "../redux/actions/Firebase";
import { getDocumentInfo } from "../redux/actions/Stations";
import { CountUp } from 'countup.js';
import Papa from "papaparse";
import "../styles/Loads.css";

import "react-sweet-progress/lib/style.css";
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

class LoadsList extends Component {
    state = {
        chartData: null,
        columns: [
            {
                title: 'Estacion',
                dataIndex: 'name',
                key: 'name',
                align: 'center',
                defaultSortOrder: 'descend',
                render: (d, i) => {
                    return i.incremental + ' - ' + i.city + ' - ' + d
                },
                sorter: (a, b) => {
                    if (a.id > b.id) {
                        return -1;
                    }
                    if (b.id > a.id) {
                        return 1;
                    }
                    return 0;
                },
            },
            {
                title: 'Fecha Inicio',
                dataIndex: 'timestamp_beginning',
                key: 'timestamp_beginning',
                align: 'center',
                defaultSortOrder: 'descend',
                sorter: (a, b) => new Date(a.timestamp_beginning).getTime() - new Date(b.timestamp_beginning).getTime(),
                render: d => (
                    moment(d).tz("America/Monterrey").format("DD/MM/YYYY HH:mm:ss").toString()
                )
            },
            {
                title: 'Fecha Fin',
                dataIndex: 'timestamp_end',
                key: 'timestamp_end',
                align: 'center',
                defaultSortOrder: 'descend',
                sorter: (a, b) => new Date(a.timestamp_end).getTime() - new Date(b.timestamp_end).getTime(),
                render: d => (
                    moment(d).tz("America/Monterrey").format("DD/MM/YYYY HH:mm:ss").toString()
                )
            },
            {
                title: 'Cliente',
                dataIndex: 'company',
                key: 'company',
                align: 'center',
                defaultSortOrder: 'descend',
                sorter: (a, b) => {
                    if (a.company > b.company) {
                        return -1;
                    }
                    if (b.company > a.company) {
                        return 1;
                    }
                    return 0;
                },
            },
            {
                title: 'kWh',
                dataIndex: 'kwh',
                key: 'kwh',
                align: 'center',
                defaultSortOrder: 'descend',
                sorter: (a, b) => a.kwh - b.kwh,
                render: kw => (
                    kw.toFixed(2)
                )
            },
            {
                title: 'Costo',
                dataIndex: 'cost',
                key: 'cost',
                align: 'center',
                defaultSortOrder: 'descend',
                sorter: (a, b) => a.cost - b.cost,
                render: cost => (
                    "$" + cost.toFixed(2)
                )
            },
        ]
    }

    componentDidMount() {
        var chartData = {
            availables: 0,
            charging: 0,
            connecting: 0,
            total: 0,
            pieData: []
        }
        this.props.stations.forEach((s, k) => {
            var arr = [];
            Object.keys(s.slots).forEach((slot, kv) => arr.push(s.slots[slot]));
            chartData.availables += arr.filter((pred, i) => { return pred.available }).length;
            chartData.charging += arr.filter((pred, i) => { return !pred.available && pred.charging }).length;
            chartData.connecting += arr.filter((pred, i) => { return !pred.available && !pred.charging }).length;
        });
        chartData.total = this.props.stations.length * 4;
        chartData.pieData.push({ name: 'Slots disponibles', value: chartData.availables });
        chartData.pieData.push({ name: 'Slots cargando', value: chartData.charging });
        chartData.pieData.push({ name: 'Slots esperando conexion', value: chartData.connecting });
        this.setState({ chartData }, () => {

            var countAvailables = new CountUp("countAvailables", chartData.availables);
            countAvailables.start();
            var countCharging = new CountUp("countCharging", chartData.charging);
            countCharging.start();
            var countConnecting = new CountUp("countConnecting", chartData.connecting);
            countConnecting.start();

        });
    }

    download_csv = (filename) => {
        const CSV = Papa.unparse(this.props.loads);
        var csvFile;
        var downloadLink;
        csvFile = new Blob([CSV], { type: 'text/csv' });
        downloadLink = document.createElement('a');
        downloadLink.download = filename;
        downloadLink.href = window.URL.createObjectURL(csvFile);
        downloadLink.style.display = 'none';
        document.body.appendChild(downloadLink);
        downloadLink.click();
    };


    handleView = (doc_name_id) => {
        // this.props.getLoadInfo(doc_name_id)
        // this.props.history.push("/viewLoad")
    }

    render() {
        return (
            <div style={{ paddingTop: 50 }}>
                <div
                    id="loadData"
                    style={{ 
                        width: '100%',
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-around",
                        marginBottom: 20
                    }}
                >
                    <div
                        className="animated fadeIn"
                        id="loadCounters"
                        style={{
                            width: "55%",
                            padding: 20,
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                        }}
                    >
                        <div style={{borderRight: '1px solid #a8a7a2', width: '30%', marginRight: 30 }}>
                            <p style={{ color: "#a8a7a2", fontWeight: 500, fontSize: 14, margin: 0 }}>Slots disponibles</p>
                            <div style={{ color: "#3b7cff", fontWeight: 600, fontSize: 25 }} id="countAvailables" />
                        </div>
                        <div style={{borderRight: '1px solid #a8a7a2', width: '30%', marginRight: 30 }}>
                            <p style={{ color: "#a8a7a2", fontWeight: 500, fontSize: 14, margin: 0 }}>Slots cargando</p>
                            <div style={{ color: "#3b7cff", fontWeight: 600, fontSize: 25 }} id="countCharging" />
                        </div>
                        <div style={{ width: '30%', marginRight: 30 }}>
                            <p style={{ color: "#a8a7a2", fontWeight: 500, fontSize: 14, margin: 0 }}>Slots esperando conexion</p>
                            <div style={{ color: "#3b7cff", fontWeight: 600, fontSize: 25 }} id="countConnecting" />
                        </div>

                    </div>
                    <div 
                        id="loadButtons"
                        style={{ 
                            width: "45%",
                            display: "flex",
                            justifyContent: "flex-end"
                        }}>
                        <Button
                            type="primary"
                            icon="file-excel"
                            size="default"
                            onClick={() => this.download_csv('cargas.csv')}
                            style={{
                                backgroundColor: 'white',
                                color: '#096dd9',
                                borderRadius: 25,
                                height: 40,
                                width: 200,
                                marginLeft: 20
                            }}
                        >
                            Descargar
                        </Button>
                        &emsp;
                        <Button
                            type="primary"
                            icon="bar-chart"
                            size="default"
                            onClick={() => this.props.history.push("/pivote")}
                            style={{
                                backgroundColor: 'white',
                                color: '#096dd9',
                                borderRadius: 25,
                                height: 40,
                                width: 200,
                                marginLeft: 20
                            }}
                        >
                            Tabla pivote
                        </Button>
                    </div>
                </div>
                <Table
                    rowClassName={"animated fadeIn"}
                    dataSource={this.props.loads}
                    columns={this.state.columns}
                    rowKey="id"
                    pagination={{
                      style: { flex: 1, width: '100%', marginTop: 25, textAlign: 'center' }
                    }}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    // console.log("SL", state.stations.data);
    return {
        loads: state.loads.data,
        stations: state.stations.data
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({ deleteDocument, getDocumentInfo }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LoadsList)